import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import type { Workspace } from '@/entities/workspace';
import { IconButton, Icons } from '@/shared/ui';

import { WorkspaceAppearanceDialog } from './WorkspaceAppearanceDialog';

/** The palette icon of the header actions; opens the appearance dialog. The server decides. */
export function WorkspaceAppearanceButton({ workspace }: { workspace: Workspace }) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  return (
    <>
      <IconButton
        label={t('workspaceHeader.open')}
        icon={<Icons.palette />}
        onClick={() => {
          setOpen(true);
        }}
      />
      {open && (
        <WorkspaceAppearanceDialog
          workspace={workspace}
          onClose={() => {
            setOpen(false);
          }}
        />
      )}
    </>
  );
}
